import React from 'react'

const Header = () => {


  return (
    <div className='flex justify-center'>
        <h1 className='flex text-5xl text-orange-500 md:p-28 p-4'>Contact list Assigment</h1>
    </div>
  )
}

export default Header